module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Close.b09f682a.svg";